import {
  createSelector,
  MemoizedSelector
} from '@ngrx/store';
import { Progression } from '@ispm-shared/modules/common';
import { State } from '../state';
import { selectState } from './pathways-state.selector';

const getPathwayTestProgression = (state: State): any => state.pathwayTestProgression;

export const selectPathwayTestProgression: MemoizedSelector<object, Progression> = createSelector(
  selectState,
  getPathwayTestProgression);


